<template>
  <div class="finacel">
    <Nav />
    <div class="top">
      <div class="money">
        <span class="t1">账户余额（元）</span>
        <span class="t2">{{ balance }}</span>
      </div>
      <router-link tag="div" :to="{name:'recharge',params:{balance:this.balance}}" class="recharge">充值</router-link>
    </div>
    <ul class="bottom">
      <router-link tag="li" to="rechlogs">
        <img class="img1" src="../../assets/my/chongzhi.png" alt />
        <span>充值记录</span>
        <img class="img2" src="../../assets/my/next2.png" alt />
      </router-link>
      <router-link tag="li" to="CapitalFlow">
        <img class="img1" src="../../assets/my/xiaofei.png" alt />
        <span>账户明细</span>
        <img class="img2" src="../../assets/my/next2.png" alt />
      </router-link>
      <router-link tag="li" to="consume">
        <img class="img1" src="../../assets/my/mingxi.png" alt />
        <span>消费记录</span>
        <img class="img2" src="../../assets/my/next2.png" alt />
      </router-link>
    </ul>
  </div>
</template>
<style lang="less" scoped>
.finacel {
  .top {
    width: 100%;
    height: 220px;
    box-sizing: border-box;
    padding: 0 24px;
    background: url("../../assets/my/myMoney.png") no-repeat;
    background-size: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .money {
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #fff;
      .t1 {
        font-size: 28px;
      }
      .t2 {
        font-size: 56px;
      }
    }
    .recharge {
      width: 104px;
      height: 48px;
      border-radius: 24px;
      background-color: #fff;
      line-height: 48px;
      text-align: center;
      color: #e42129;
      font-size: 24px;
    }
  }
  .bottom {
    margin-top: 20px;
    li {
      background-color: #fff;
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      padding: 0 24px;
      box-sizing: border-box;
      margin-bottom: 2px;
    
      .img1{
        width: 28px;
      }
      span{
        flex: 1;
        margin-left: 20px;
        font-size: 28px;
        color: #333;
      }
      .img2{
        width: 20px;
      }
    }
  }
}
</style>

<script>
export default {
  data(){
    return{
      balance:0
    }
  },
  created(){
    this.balance = this.$route.query.balance || 0.00
  },
}
</script>
